<template>
  <transition name="slide">
    <div v-if="isOpen" class="SideMenu relative z-50">
      <nav class="bg-white p-10 w-full h-full overflow-y-auto relative z-40">
        <button class="absolute top-5 right-5" type="button" :title="$t('close')" @click="close">
          <svg-icon-close class="text-black" width="35" height="35" />
        </button>

        More About the product
      </nav>

      <transition name="fade">
        <div v-if="isOpen" class="bg-black fixed inset-0 w-full h-full opacity-60 z-30" @click="close"></div>
      </transition>
    </div>
  </transition>
</template>

<script setup lang="ts">
defineComponent({
  name: 'SideMenu',
});

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: Boolean,
});

const isOpen = ref(props.modelValue);

watch(
  () => props.modelValue,
  value => {
    isOpen.value = value;
  },
);

function close() {
  emit('update:modelValue', false);
}
</script>

<style lang="postcss" scoped>
.SideMenu {
  @apply fixed bottom-0 top-0 right-0;
  width: 100%;

  @screen md {
    width: 50vw;
  }
  height: 100vh;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  transform: translate3d(100%, 0px, 0);
}
</style>

<i18n>
{
  "en": {
    "close":  "Close"
  },
  "ar": {
    "close": "غلق"
  }
}
</i18n>
